export default __webpack_public_path__ + "static/ti_motorhome_logo-c662c5fc526ffdb73e8e0624a91c5ec4.svg";